/** Opt-in dev logging: set REACT_APP_VERBOSE_LOGS=true in .env.local */
const verbose =
  process.env.NODE_ENV !== 'production' && process.env.REACT_APP_VERBOSE_LOGS === 'true';

export function devLog(...args: unknown[]): void {
  if (verbose) console.log(...args);
}
